import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51bfb5e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  id: "consent"
}
const _hoisted_3 = { class: "section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Confirm what we will share", -1))
const _hoisted_5 = {
  key: 0,
  class: "headerbar"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h6 p15",
  style: {"flex-grow":"1"}
}, "Accounts", -1))
const _hoisted_7 = {
  key: 0,
  class: "updated"
}
const _hoisted_8 = { class: "section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h6",
  style: {"flex-grow":"1"},
  title: "data requested"
}, " Data Requested ", -1))
const _hoisted_10 = {
  key: 0,
  class: "updated"
}
const _hoisted_11 = { style: {"flex-grow":"1"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" This includes: ")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Historical data required", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" This may include data that may date back to 25th August 2021 ")
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "section" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h6",
  style: {"flex-grow":"1"},
  title: "sharing period"
}, " Sharing period ", -1))
const _hoisted_20 = {
  key: 0,
  class: "updated"
}
const _hoisted_21 = { class: "small" }
const _hoisted_22 = {
  key: 0,
  class: "small"
}
const _hoisted_23 = {
  key: 1,
  class: "small"
}
const _hoisted_24 = { class: "section" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "h6",
  title: "manage your data sharing"
}, " Manage your data sharing ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small" }, " On the SocietyOne App, you can go to 'Settings > Data Sharing' to review this arrangement and stop sharing your data. ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small" }, " You can also tell us to stop sharing your data by contacting us via the in app chat. ", -1))
const _hoisted_28 = { class: "section error" }
const _hoisted_29 = { class: "info-panel" }
const _hoisted_30 = { style: {"padding":"10px"} }
const _hoisted_31 = { class: "h6" }
const _hoisted_32 = {
  class: "section button-bar",
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListAccounts = _resolveComponent("ListAccounts")!
  const _component_panel = _resolveComponent("panel")!
  const _component_PanelGroup = _resolveComponent("PanelGroup")!
  const _component_ExpandableTextbox = _resolveComponent("ExpandableTextbox")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      (_ctx.consentRequest)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("p", null, " Please confirm that you agree to share the following data with " + _toDisplayString(_ctx.consentRequest.recipient.clientName) + ". ", 1)
            ]),
            (_ctx.applicationStore.selectedAccounts.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  (
            _ctx.consentRequest?.existingArrangement?.attachedAccounts &&
            !_ctx.arrayEquals(
              _ctx.consentRequest?.existingArrangement?.attachedAccounts,
              _ctx.applicationStore.selectedAccounts
            )
          )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Updated"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.applicationStore.selectedAccounts.length > 0)
              ? (_openBlock(), _createBlock(_component_ListAccounts, {
                  key: 1,
                  "show-heading": false,
                  accounts: 
          _ctx.applicationStore.allAccounts.filter((sub) =>
            _ctx.applicationStore.selectedAccounts.includes(sub.subscriptionKey)
          )
        
                }, null, 8, ["accounts"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_PanelGroup, null, {
                heading: _withCtx(() => [
                  _hoisted_9,
                  (
                _ctx.consentRequest?.existingArrangement?.scope &&
                _ctx.consentRequest?.existingArrangement?.scope !==
                  _ctx.consentRequest?.consentRequested?.scope
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Updated"))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationStore.dataClusters, (dataCluster, name) => {
                    return (_openBlock(), _createBlock(_component_panel, {
                      collapsible: true,
                      key: name
                    }, {
                      heading: _withCtx(() => [
                        _createElementVNode("a", _hoisted_11, _toDisplayString(name), 1)
                      ]),
                      content: _withCtx(() => [
                        _hoisted_12,
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataCluster, (item) => {
                            return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
                          }), 128))
                        ]),
                        (name === 'Transaction details')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_17))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_panel, null, {
                heading: _withCtx(() => [
                  _hoisted_19,
                  (_ctx.consentRequest?.existingArrangement)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Updated"))
                    : _createCommentVNode("", true)
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_ExpandableTextbox, null, {
                    minimized: _withCtx(() => [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.duration.start.toLocaleDateString()) + " - " + _toDisplayString(_ctx.duration.end.toLocaleDateString()), 1)
                    ]),
                    expanded: _withCtx(() => [
                      (Math.abs(_ctx.duration.end - _ctx.duration.start) > 86410000)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_22, " We will share your data on an ongoing basis until " + _toDisplayString(_ctx.duration.end.toLocaleDateString()) + ". ", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_23, "We will share your data once."))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_panel, null, {
                heading: _withCtx(() => [
                  _hoisted_25
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_ExpandableTextbox, null, {
                    minimized: _withCtx(() => [
                      _hoisted_26
                    ]),
                    expanded: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.errorMessage), 1)
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, " Do you allow us to share your data with " + _toDisplayString(_ctx.applicationStore.consentRequest.recipient.clientName) + "? ", 1),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("button", {
            title: "Authorise",
            name: "authorise",
            class: "medium so-primary-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.authorise(true))),
            style: {"min-width":"120px"}
          }, " Authorise "),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              title: "Deny",
              name: "cancel",
              class: "medium so-secondary-1",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.authorise(false))),
              style: {"min-width":"120px"}
            }, " Deny ")
          ])
        ]),
        _createVNode(_component_Footer)
      ])
    ])
  ], 64))
}